import { render } from "./menu-right.vue?vue&type=template&id=6311926e&scoped=true"
import script from "./menu-right.vue?vue&type=script&lang=js"
export * from "./menu-right.vue?vue&type=script&lang=js"

import "./menu-right.vue?vue&type=style&index=0&id=6311926e&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6311926e"]])

export default __exports__